export enum SupportedPayoutMethodType {
  CANADIAN_BANK_ACCOUNT = 'CANADIAN_BANK_ACCOUNT',
  US_BANK_ACCOUNT = 'US_BANK_ACCOUNT',
}

export enum SupportedAccountHolderType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
}
